<template>
<table :width="width" class="left">
  <table class=" TB_COLLAPSE" width="100%">
    <thead>
      <tr>
        <th colspan="5">{{title}}</th>
      </tr>
      <th width="20%">序号</th>
      <th width="40%">选项</th>
      <th width="20%">占成</th>
      <th width="20%">补货</th>
    </thead>
    <tbody>
      <tr v-for="(it, index ) in historyData" :key="index+'tc'" class="tc">
        <td>{{index+1}}</td>
        <td>{{it.title}} - {{it.mark}}</td>
        <td>{{it.l1tl}}</td>
        <td>{{Math.round(it.buvalue)}}</td>
      </tr>
      <tr v-if="table==''"><td colspan="4">无资料</td></tr>
    </tbody>
  </table>
  <Page class="mt-2 right"  :total="dataCount" :page-size="pageSize" simple @on-change="changepage"></Page>
</table>
</template>

<script>
export default {
  props: {
    title: String,
    width: String,
    table: {
      type: Array,
      default: () => ({
        pcol: String,
        odddtl: 0,
        troddid: 0,
        mark: 0,
        buvalue: 0
      })
    }
  },
  data() {
    return {
      ajaxHistoryData: [],
      // 初始化信息总条数
      dataCount: 0,
      // 每页显示多少条
      pageSize: 10,
      historyData: []
    };
  },
  created(){
    this.handleListApproveHistory()
  },
  watch:{
    table(val){
      this.handleListApproveHistory()
    }
  },
  methods: {
    // 获取历史记录信息
    handleListApproveHistory() {
      // 保存取到的所有数据
      this.ajaxHistoryData = this.table;
      this.dataCount = this.table.length;
      // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
      if (this.table.length < this.pageSize) {
        this.historyData = this.ajaxHistoryData;
      } else {
        this.historyData = this.ajaxHistoryData.slice(0, this.pageSize);
      }
    },
    changepage(index) {
      var _start = (index - 1) * this.pageSize;
      var _end = index * this.pageSize;
      this.historyData = this.ajaxHistoryData.slice(_start, _end);
    }
  },

};
</script>